<template>
  <!-- <canvas
    :id="`highlight-${pageNumber}`"
    v-bind="overlayAttributesSimple"
    :class="{ resourceHighlights: true, screenShot: isScreenCapEnabled, 'overlay-page': true }"
    @mousedown="mouseDown($event)"
    @mouseup="mouseUp($event)"
    @mousemove="mouseMove($event)"
  ></canvas> -->
  <div
    :id="`highlight-${pageNumber}`"
    ref="highlight"
    v-bind="overlayAttributesSimple"
    :class="{ resourceHighlights: true, screenShot: isScreenCapEnabled, 'overlay-page': true }"
  >
    <div
      v-for="selection in pageSelections"
      :key="selection.x + selection.y"
      :class="
        `pdf-highlight excerpt-${selection.id} ${hovering == selection.id ? 'hovering' : null}`
      "
      @mouseover="hovering = selection.id"
      @mouseleave="hovering = false"
      @click="$emit('selectExcerpt', selection.id)"
      :style="
        `position: absolute; left: ${selection.x * pageWidth}px; top: ${selection.y *
          pageHeight}px; width: ${selection.width * pageWidth}px; height: ${selection.height *
          pageHeight}px; z-index: ${selecting ? '0' : '2'}`
      "
    ></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'HighlightCanvas',
  data() {
    return {
      pageWidth: 0,
      pageHeight: 0,
      hovering: false
    };
  },
  props: {
    overlayAttributesSimple: {
      type: Object,
      required: true
    },
    pageNumber: {
      pageNumber: Number,
      required: true
    },
    scale: {
      type: Number,
      required: true
    },
    selecting: {
      type: Boolean
    }
  },
  computed: {
    ...mapState('components/pdfViewer', ['isScreenCapEnabled']),
    ...mapGetters('components/pdfViewer', ['savedSelections']),
    pageSelections() {
      const { savedSelections } = this;
      console.log('savedSelections', savedSelections);
      const filteredSelections = savedSelections.filter(selection => {
        return selection.pages.includes(this.pageNumber);
      });
      const actualSelections = [];
      filteredSelections.forEach(selection => {
        selection.positions.forEach(domRect => {
          if (domRect.page === this.pageNumber) {
            actualSelections.push({ ...domRect, type: selection.type, id: selection.excerptId });
          }
        });
      });
      return actualSelections;
    }
  },
  methods: {
    clearCanvas() {
      const screenShotCanvas = this.$el;
      const ctx = screenShotCanvas.getContext('2d');
      //ctx.clearRect(0, 0, screenShotCanvas.width, screenShotCanvas.height);
    },
    drawAllSelections() {
      this.clearCanvas();
      const { pageSelections } = this;
      if (pageSelections.length > 0) {
        const screenShotCanvas = this.$el;
        const ctx = screenShotCanvas.getContext('2d');
        const pageWidth = this.$el.width;
        const pageHeight = this.$el.height;
        pageSelections.forEach(domRect => {
          if (domRect.type === 'textExcerpt') {
            ctx.fillStyle = 'rgba(255, 255, 0, 0.3)';
            const x = domRect.x * pageWidth;
            const y = domRect.y * pageHeight;
            const width = domRect.width * pageWidth;
            const height = domRect.height * pageHeight;
            ctx.fillRect(x, y, width, height);
          } else if (domRect.type === 'imageExcerpt') {
            ctx.fillStyle = 'rgba(0, 255, 255, 0.3)';
            const x = domRect.x * pageWidth;
            const y = domRect.y * pageHeight;
            const width = domRect.width * pageWidth;
            const height = domRect.height * pageHeight;
            ctx.fillRect(x, y, width, height);
          }
        });
      }
    }
  },
  watch: {
    pageSelections() {
      console.log('page selections changed, redrawing');
      //this.drawAllSelections();
    },
    overlayAttributesSimple() {
      console.log('overlayAttributesSimple Changed in Highlights');
      this.$nextTick(() => {
        //this.drawAllSelections();
      });
    },
    scale() {
      this.$nextTick(() => {
        this.pageWidth = this.$el.offsetWidth;
        this.pageHeight = this.$el.offsetHeight;
      });
    }
  },
  mounted() {
    //this.drawAllSelections();
    console.log(this.$el);
    this.pageWidth = this.$el.offsetWidth;
    this.pageHeight = this.$el.offsetHeight;
  }
};
</script>
<style scoped>
.pdf-highlight {
  background: rgba(255, 255, 0, 0.3);
}

.pdf-highlight.hovering {
  background: rgba(255, 255, 0, 0.5);
}

.resourceHighlights {
  opacity: 1;
}

.resourceHighlights.screenShot {
  opacity: 0;
}
</style>
